import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthModule } from '@nx/auth';
import { RouterModule } from '@angular/router';
import { AuthProcessService } from './common/services/auth-process.service';
import { AppStates } from './common/routing/app.states';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { UserSignedInGuard } from './common/routing/user-signed-in.guard';
import { ModalHeaderModule } from '@nx/mono-common';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([...AppStates]),
    AuthModule,
    StoreDevtoolsModule.instrument({
      maxAge: 25,
    }),
    ModalHeaderModule
  ],
  declarations: [],
  providers: [
    AuthProcessService, UserSignedInGuard
  ]
})
export class LmwAuthModule { }
